import { Tipping1CardSchema, Tipping2CardSchema } from "@stackje/common/config";
import type { Tipping1Card, Tipping2Card } from "@stackje/common/config";

export function parseTippingCard(formData: FormData): Tipping1Card | Tipping2Card {
  const type = formData.get("type") as "tipping1" | "tipping2";
  const paymentMethod = formData.get("paymentMethod") as "paynow";
  
  // Parse payee info based on payment method
  const payeeInfo: { paynow?: { type: "MOBILE" | "UEN"; value: string; recipientName?: string; } } = {};
  if (paymentMethod === "paynow") {
    const payeeType = formData.get("payeeInfo.paynow.type") as "MOBILE" | "UEN";
    const payeeValue = formData.get("payeeInfo.paynow.value") as string;
    const recipientName = formData.get("payeeInfo.paynow.recipientName") as string;
    
    payeeInfo.paynow = {
      type: payeeType,
      value: payeeValue,
      recipientName: recipientName || undefined,
    };
  }
  
  // Parse amounts array
  const amountsStr = formData.get("amounts") as string;
  const amounts = amountsStr ? JSON.parse(amountsStr) : [5, 10, 20, 50];
  
  // Parse other fields
  const allowCustomAmount = formData.get("allowCustomAmount") === "true";
  const minAmount = parseFloat(formData.get("minAmount") as string) || 1;
  const maxAmount = parseFloat(formData.get("maxAmount") as string) || 999;
  
  const cardData = {
    type,
    title: formData.get("title") as string,
    description: (formData.get("description") as string) || undefined,
    paymentMethod,
    payeeInfo,
    amounts,
    allowCustomAmount,
    minAmount,
    maxAmount,
    currency: (formData.get("currency") as string) || "SGD",
    buttonText: (formData.get("buttonText") as string) || "Generate QR Code",
    thankYouNote: (formData.get("thankYouNote") as string) || "Thank you for your support! 🙏",
    colors: JSON.parse(formData.get("colors") as string),
  };
  
  // Validate with appropriate schema
  if (type === "tipping1") {
    return Tipping1CardSchema.parse(cardData);
  } else {
    return Tipping2CardSchema.parse(cardData);
  }
}